import { render, staticRenderFns } from "./TestConfigDetail.vue?vue&type=template&id=b65a4706"
import script from "./TestConfigDetail.vue?vue&type=script&lang=js"
export * from "./TestConfigDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports